export const LEAD_STATUS_OPTIONS = [
  { value: "", label: "همه وضعیت‌ها" },
  { value: "Registered", label: "ثبت‌نام شده" },
  { value: "ProfileCompleted", label: "پروفایل تکمیل شده" },
  { value: "NoProject", label: "فاقد درخواست" },
  { value: "HasProject", label: "دارای درخواست نیروگاه" },
];

export const PROJECT_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "NotCreated", label: "ثبت نشده" },
  { value: "Submitted", label: "ثبت درخواست شده" },
  { value: "UnderReview", label: "در حال بررسی" },
  { value: "DocsIncomplete", label: "مدارک ناقص" },
  { value: "VisitPending", label: "در انتظار بازدید" },
  { value: "ContractStage", label: "در مرحله قرارداد" },
  { value: "InExecution", label: "در حال اجرا" },
  { value: "Commissioned", label: "بهره‌برداری شده" },
];

export const MEHRSAN_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "NotRegistered", label: "ثبت نشده" },
  { value: "PendingRegistration", label: "در انتظار ثبت" },
  { value: "RegisteredInMehrsan", label: "ثبت در مهرسان" },
  { value: "InProgress", label: "در حال پیگیری" },
  { value: "Completed", label: "تکمیل شده" },
  { value: "Unknown", label: "نامشخص" },
];

export const LOAN_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "NotRequired", label: "نیاز ندارد" },
  { value: "PendingReview", label: "در انتظار بررسی" },
  { value: "CreditCheck", label: "در حال اعتبارسنجی" },
  { value: "Approved", label: "تایید شده" },
  { value: "Rejected", label: "رد شده" },
  { value: "DocsPending", label: "در حال تکمیل مدارک" },
  { value: "Unknown", label: "نامشخص" },
];

export const COMMISSION_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "None", label: "ایجاد نشده" },
  { value: "Calculated", label: "محاسبه شده" },
  { value: "Approved", label: "تایید شده" },
  { value: "Payable", label: "قابل تسویه" },
  { value: "Paid", label: "پرداخت شده" },
];

const CHIP_COLORS = {
  Registered: "info",
  ProfileCompleted: "info",
  NoProject: "default",
  HasProject: "success",
  Submitted: "success",
  UnderReview: "warning",
  DocsIncomplete: "warning",
  VisitPending: "warning",
  ContractStage: "primary",
  InExecution: "primary",
  Commissioned: "success",
  Rejected: "error",
  Paid: "success",
  Payable: "success",
  Approved: "success",
  Unknown: "default",
  NotRegistered: "default",
  NotRequired: "default",
  None: "default",
  InProgress: "warning",
  PendingReview: "warning",
  CreditCheck: "warning",
};

export const getStatusChipColor = (statusKey) =>
  CHIP_COLORS[statusKey] || "default";
